/** Пути к листу A3 в public (альбомная = NPOV, книжная = POV). */

export function getSheetBackgroundPath(isLandscape, withWatermark = true) {
  if (withWatermark) {
    return isLandscape ? '/A3React(NPOV).png' : '/A3React(POV).png';
  }
  return isLandscape ? '/A3React(NPOV)NW.png' : '/A3React(POV)NW.png';
}

export function loadSheetBackgroundImage(isLandscape, withWatermark) {
  const url = `${process.env.PUBLIC_URL}${getSheetBackgroundPath(isLandscape, withWatermark)}`;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Не удалось загрузить фон: ${url}`));
    img.src = url;
  });
}
